import 'core-js/es6/promise';
import 'core-js/modules/es6.object.assign';
import 'whatwg-fetch';

import '../../common/modules/global';
import GdprManager from '../../common/gdpr/gdpr-manager';
import '../../common/modules/analytics';

import { FooterMenuAccordion } from 'wg5/src/modules/organisms/footer/footer';
import 'wg5/src/modules/organisms/header/header';
import { removeFocusOnClick } from 'wg5/src/modules/atoms/remove-focus-on-click/removeFocusOnClick';

import LazyLoad from '../../common/modules/lazy-load';
import { experimentVP } from "../price/includes/experiment";

class Rebranding {
    constructor() {
        Promise.all([
            this.initCards(),
            this.initCardsSlider(),
            this.initCTAWidget(),
            this.initFaq(),
            this.initContactUsWidget(),
            this.initPriceWidget(),
            this.initCustomersQuote(),
            this.initIntro(),
            this.initCustomerFilter(),
            this.initFeatureSlider(),
            this.initParallax(),
            LazyLoad.initImg(),
            LazyLoad.initVideo()
        ]).then((values) => {
            import('../../common/modules/init-wg');
        });

        this.initGDPR();
        this.initAffiliateOrPartnerCookie();
        this.changeLoginLink();
        this.initModalHashOpening();
        this.initFooterMenuAccordion();
        this.initContactUsPopup();
        removeFocusOnClick();
        this.initAnchors();
    }

    initGDPR() {
        const gdprManager = new GdprManager();
        gdprManager.init();
    }

    initAffiliateOrPartnerCookie() {
        var codeRegex = /[^\w]/g;

        var partnerCode = window.wrike.getGETParameterByName('r').replace(codeRegex, '');
        var saleCode = window.wrike.getGETParameterByName('sales').replace(codeRegex, '');

        if (partnerCode.length) {
            WG.utils.setCookie('partner_referral_code', partnerCode, {
                expires: window.wrike.getDatePlus31(),
                path: '/'
            });
        }

        if (saleCode.length) {
            WG.utils.setCookie('sales_referrer_name', saleCode, {
                expires: window.wrike.getDatePlus31(),
                path: '/'
            });
        }
    }

    initModalHashOpening() {
        var hash = location.hash.replace(/^#/, '');
        var modal;

        if (hash) {
            modal = $('.wg-modal')
                .filter('[data-hash="' + hash + '"]')
                .eq(0);

            if (modal.length) {
                modal.on('ready.wg.modal', function() {
                    $(this)
                        .wgInstance()
                        .show();
                });
            }
        }
    }

    changeLoginLink() {
        let allowedHosts = ['www.wrike.com', 'alpha.wrke.io', 'rc.wrke.io', 'rctests.wrke.io', 'trtests.wrke.io'],
            currentHost = window.location.host;

        if (!allowedHosts.includes(currentHost)) {
            let links = Array.from(document.querySelectorAll('a[href$="/login/"]'));

            for (let i = 0; i < links.length; i++) {
                let link = links[i],
                    envPosition = -1;

                for (let j = 0; j < allowedHosts.length; j++) {
                    envPosition = currentHost.search(allowedHosts[j]);

                    if (envPosition !== -1) {
                        if (currentHost.slice(0, envPosition) === 'read-') {
                            link.href = ['https://login-', currentHost.slice(envPosition), '/login/?read'].join('');
                        } else {
                            link.href = [
                                'https://',
                                currentHost.slice(0, envPosition),
                                'login-',
                                currentHost.slice(envPosition),
                                '/login/'
                            ].join('');
                        }
                        break;
                    }
                }
            }
        }
    }

    initFooterMenuAccordion() {
        new FooterMenuAccordion('.footer-nav__title, .footer-nav__spoiler');
    }

    initParallax() {
        const domNodes = [].slice.call(document.querySelectorAll('.widget-features--promo__parallax'));

        if (domNodes.length < 1) return;

        // prettier-ignore
        return import(
            /* webpackChunkName: "widget-promo-parallax" */
            'wg5/src/modules/widgets/widget-promo/promo-parallax'
        ).then(({ PromoParallax }) => {
            domNodes.forEach((item) => {
                const parallax = new PromoParallax(item);
                if (item.querySelector('.widget-features__inner-img--parallax')) {
                    parallax.init();
                }
            });
        });
    }

    initFeatureSlider() {
        const domNodes = [].slice.call(document.querySelectorAll('.widget-features__wrap--slider'));

        if (domNodes.length < 1) return;

        // prettier-ignore
        return import(
            /* webpackChunkName: "widget-feature-slider" */
            'wg5/src/modules/widgets/feature-slider/feature-slider'
        ).then(({ NavigationTabsSlider }) => {
            domNodes.forEach((item) => {
                const slider = new NavigationTabsSlider(item);
                slider.init();
            });
        });
    }

    initFaq() {
        const domNodes = [].slice.call(document.querySelectorAll('.faq-card'));

        if (domNodes.length < 1) return;

        // prettier-ignore
        return import(
            /* webpackChunkName: "widget-faq" */
            'wg5/src/modules/widgets/widget-faq/faq-card-accordion'
        ).then(({ FaqCardAccordion }) => {
            domNodes.forEach((item) => {
                const accordion = new FaqCardAccordion(item);

                accordion.init();
            });
        });
    }

    initCustomersQuote() {
        const domNodes = [].slice.call(document.querySelectorAll('.widget-customers'));

        if (domNodes.length < 1) return;

        // prettier-ignore
        return import(
            /* webpackChunkName: "widget-customers-quote" */
            'wg5/src/modules/widgets/widget-customers-quote/widget-customers-quote'
        ).then(({ WidgetCustomersQuote }) => {
            domNodes.forEach((item) => {
                const slider = new WidgetCustomersQuote(item);

                slider.init();
            });
        });
    }

    initIntro() {
        const domNodes = [].slice.call(document.querySelectorAll('.widget-intro'));

        if (domNodes.length < 1) return;

        // prettier-ignore
        return import(
            /* webpackChunkName: "widget-intro" */
            'wg5/src/modules/widgets/widget-intro/widget-intro'
        ).then(({ WidgetIntro }) => {
            domNodes.forEach((item) => {
                new WidgetIntro(item);
            });
        });
    }

    initCards() {
        const domNodes = [].slice.call(document.querySelectorAll('.widget-cards'));

        if (domNodes.length < 1) return;

        // prettier-ignore
        return import(
            /* webpackChunkName: "widget-cards" */
            'wg5/src/modules/widgets/widget-cards/widget-cards'
        ).then(({ WidgetCards }) => {
            domNodes.forEach((item) => {
                const widgetCards = new WidgetCards(item);

                widgetCards.init();
            });
        });
    }

    initCardsSlider() {
        const domNodes = [].slice.call(document.querySelectorAll('.widget-cards--with-slider'));

        if (domNodes.length < 1) return;

        // prettier-ignore
        return import(
            /* webpackChunkName: "widget-cards-with-slider" */
            'wg5/src/modules/widgets/widget-cards/widget-cards-slider'
        ).then(({ WidgetCardsSlider }) => {
            domNodes.forEach((item) => {
                const slider = new WidgetCardsSlider(item);

                slider.init();
            });
        });
    }

    initPriceWidget() {
        const domNodes = [].slice.call(document.querySelectorAll('.widget-price-plans'));

        if (domNodes.length < 1) return;

        // prettier-ignore
        return import(
            /* webpackChunkName: "price-widget" */
            'wg5/src/modules/widgets/widget-price-plans/widget-price-plans'
        ).then(({ PriceWidget }) => {
            domNodes.forEach((item) => {
                const price = new PriceWidget(item);

                price.init();
            });
        });
    }

    initCTAWidget() {
        const domNodes = [].slice.call(document.querySelectorAll('.widget-cta'));

        if (domNodes.length < 1) return;

        // prettier-ignore
        return import(
            /* webpackChunkName: "widget-cta" */
            'wg5/src/modules/widgets/widget-cta/widget-сta'
        ).then(({ WidgetCta }) => {
            domNodes.forEach((item) => {
                new WidgetCta(item);
            });
        });
    }

    initContactUsWidget() {
        const domNodes = [].slice.call(document.querySelectorAll('.widget-contact-us'));

        if (domNodes.length < 1) return;

        // prettier-ignore
        return import(
            /* webpackChunkName: "widget-contact-us" */
            'wg5/src/modules/widgets/widget-contact-us/widget-contact-us'
        ).then(({ WidgetContactUs }) => {
            domNodes.forEach((item) => {
                new WidgetContactUs(item);
            });
        });
    }

    initContactUsPopup() {
        const formsCollection = [].slice.call(document.querySelectorAll('.contact-us-popup-form'));

        if (formsCollection.length < 1) return;

        // prettier-ignore
        return import(
            /* webpackChunkName: "contact-form-chunk" */
            'wg5/src/modules/molecules/contact-form/contact-form'
        ).then(({ ContactForm }) => {
            formsCollection.forEach((item) => {
                const contactForm = new ContactForm(item);
                contactForm.init();
            });
        });
    }

    initCustomerFilter() {
        const domNodes = [].slice.call(document.querySelectorAll('.widget-customer-filter'));

        if (domNodes.length < 1) return;

        // prettier-ignore
        return import(
            /* webpackChunkName: "widget-customer-filter" */
            './customer-filter'
        ).then(({ WidgetCustomerFilter }) => {
            domNodes.forEach((item) => {
                new WidgetCustomerFilter(item);
            });
        });
    }

    initAnchors() {
        $('.header-list__link[href^="#"]').on('click', (e) => {
            e.preventDefault();

            $('.header-nav-button').click();
            const id = e.target.attributes.href.value;

            require('../../vendor/jquery.scrollTo.min');
            setTimeout(() => {
                $.scrollTo(id, 1000, { offset: { top: -100 } });
            }, 500);
        });
    }
}

new Rebranding();



// WEBPACK FOOTER //
// ./assets/js/projects/rebranding/rebranding.js